import { useMemo } from 'react';
import { RadioContext } from './RadioContext';

export const RadioGroup = ({
    name, value, disabled = false, required = false, onChange, children,
}) => {
    const contextValue = useMemo(() => ({
        name, disabled, selected: value, onChange, required,
    }), [disabled, name, value, onChange, required]);

    return (
        <RadioContext.Provider value={contextValue}>
            {children}
        </RadioContext.Provider>
    );
};